var styleDataHash = "8938bd52";
const injectCss = () => {
  var css = `.UoTJ4{--wds-side-panel-floating-header-padding-left:18px;--wds-side-panel-footer-padding-horizontal:18px}._28DDD{--wds-color-fill-standard-tertiary-hover:rgba(0,0,0,.1)}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var panel_default = {
  "modal": "UoTJ4",
  "liveSite": "_28DDD"
};
export {
  panel_default as default,
  injectCss
};
//# sourceMappingURL=panel-scss.js.map
